const sm = (strings) => {
  return `
    @media (min-width: 576px) {
      ${strings.raw}
    }
  `;
};

const md = (strings) => {
  return `
    @media (min-width: 768px) {
      ${strings.raw}
    }
  `;
};

const lg = (strings) => {
  return `
    @media (min-width: 992px) {
      ${strings.raw}
    }
  `;
};

const xl = (strings) => {
  return `
    @media (min-width: 1200px) {
      ${strings.raw}
    }
  `;
};

export default {
  sm,
  md,
  lg,
  xl,
};



// WEBPACK FOOTER //
// ./src/util/breakpoints.js